export const ADMIN_CATEGORIES = [
  "Bancário",
  "Consumidor",
  "Cível/Contratos",
  "Trabalhista",
  "Previdenciário",
  "Penal"
];

export async function fetchArticles() {
  const response = await fetch("/data/artigos.json", { cache: "no-store" });
  if (!response.ok) {
    throw new Error("Não foi possível carregar os artigos.");
  }
  const articles = await response.json();
  if (!Array.isArray(articles)) return [];
  return [...articles].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  );
}

export async function loginAdmin(password) {
  const response = await fetch("/api/admin/login", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password })
  });
  if (response.status === 404) {
    throw new Error(
      "O login do admin só existe no servidor de desenvolvimento (npm/yarn start). Em produção estática não há API — é preciso servir as rotas /api no host."
    );
  }
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error || "Falha no login.");
  }
}

export async function checkAdminSession() {
  const response = await fetch("/api/admin/session", { cache: "no-store" });
  if (!response.ok) return false;
  const payload = await response.json().catch(() => ({}));
  return Boolean(payload.authenticated);
}

export async function publishArticle(article) {
  const response = await fetch("/api/artigos", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(article)
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error || "Não foi possível publicar.");
  }
  return response.json();
}
